import { Stack } from "@mui/material";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import LanguageSwitcher from "Components/Shared/LanguageSwitcher/LanguageSwitcher";
import { Resources, useResource } from "Translations/Resources";
import { PaperTitle } from "Components/Shared/PaperTitle";

export const LanguageSettingsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(Resources.Pages.Titles.LanguageSettings)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <div className="left-content">
          <PrimaryPaper>
            <Stack gap={3}>
              <PaperTitle>{t(Resources.Language.Language)}</PaperTitle>
              <LanguageSwitcher />
            </Stack>
          </PrimaryPaper>
        </div>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default LanguageSettingsPage;
